import { Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { options } from 'src/app/shared/models/profile/trips';
import { ageRangeOptions, countryOption, genderOptions } from 'src/app/shared/utilities/constants';
import { AgreementType } from 'src/app/shared/enum';
import { NgForm } from '@angular/forms';
import { PhoneValidatorService } from 'src/app/modules/home/service/phone-validator.service';
@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['../../auth-connect/auth-connect.component.scss', './personal-info.component.scss']
})
export class PersonalInfoComponent {
  @Input() userProfile: any;
  @Output() userProfileChange = new EventEmitter<any>();
  @Input() page!: any;
  @Input() showFormNavigationBtn = true;
  @Input() showUserConsentCheckbox = true;
  @Input() hidePhoneNumber = false;
  @Output() signUpPageCount = new EventEmitter<number>();
  @ViewChild('userinfoAuthForm') userinfoAuthForm !: NgForm
  pdfSource: any;
  filterOptions: options[] = countryOption;
  ageRangeOptions = ageRangeOptions;
  genderOptions = genderOptions;
  signUpCount: number = 3;
  elementName: string = 'email';
  privacyPolicy = AgreementType.PolicyAgreement
  termsAndConditions = AgreementType.TermsAgreement
  phoneValidatorService = inject(PhoneValidatorService);

  //signup
  onTermsClick(agreementType:string): void {
    if(agreementType === this.privacyPolicy)  window.open(window.location.origin+'/privacy')
    if(agreementType === this.termsAndConditions) window.open(window.location.origin+'/termsandconditions')
  }

  trimName(fieldName:string){
    if(fieldName ==='fname') this.userProfile.fname = this.userProfile?.fname?.trim()
    else this.userProfile.lname = this.userProfile?.lname?.trim()
  }

  formatPhoneNumber(event: any) {
    this.userProfile.phone = this.phoneValidatorService.formatPhoneNumber(event, this.userinfoAuthForm?.controls['phone'], this.userProfile.country);
  }

}
